import { render, staticRenderFns } from "./indexB.vue?vue&type=template&id=a27cab2c&scoped=true&"
import script from "./indexB.vue?vue&type=script&lang=js&"
export * from "./indexB.vue?vue&type=script&lang=js&"
import style0 from "./indexB.vue?vue&type=style&index=0&id=a27cab2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27cab2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VDivider,VFlex,VLayout,VSelect})
